import * as React from 'react';
import { PlayStateEnum } from '../interfaces/state';
import { KeyboardShortcutTooltip } from '../../../misc/components/KeyboardShortcutTooltip';
import { OnIgnoreEnter } from '../AnalyseApp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch, faPause, faPlay } from '@fortawesome/free-solid-svg-icons';

interface PlayPauseProps {
    isLoading: boolean;
    isPlaying: PlayStateEnum;
    isDisabled?: boolean;
    isKeyboardShortcutVisible: boolean;
    onPlayClick: () => void;
    onPauseClick: () => void;
}

export const PlayPause = (props: PlayPauseProps) => {
    if (props.isLoading) {
        return (
            <button id="Playback" className="btn btn-primary" disabled>
                <FontAwesomeIcon icon={faCircleNotch} className="fa-spin fa-fw" aria-hidden="true" />&nbsp;
                Loading
            </button>
        );
    } else if (props.isPlaying == PlayStateEnum.Playing) {
        return (
            <button id="Playback" className="btn btn-primary" onClick={(e: any) => { e.target.blur(); props.onPauseClick() }} onKeyDown={OnIgnoreEnter}>
                <FontAwesomeIcon icon={faPause} aria-hidden="true" />
                <KeyboardShortcutTooltip show={props.isKeyboardShortcutVisible} keyName="SPACE" />
            </button>
        );
    } else if (props.isPlaying == PlayStateEnum.NotStarted || props.isPlaying == PlayStateEnum.Paused) {
        return (
            <button id="Playback" className="btn btn-primary" disabled={props.isDisabled} onClick={(e: any) => { e.target.blur(); props.onPlayClick() }} onKeyDown={OnIgnoreEnter}>
                <FontAwesomeIcon icon={faPlay} aria-hidden="true" />
                <KeyboardShortcutTooltip show={props.isKeyboardShortcutVisible} keyName="SPACE" />
            </button>
        );
    } else {
        return null;
    }
}
